import formatCurrency from '@/utils/format-currency';

interface PriceRangeProps {
  min_total_nt: number;
  max_total_nt: number;
}

const PriceRange = ({
  min_total_nt = 0,
  max_total_nt = 0,
}: PriceRangeProps) => {
  const hasMaxTotal = min_total_nt !== max_total_nt;
  return (
    <div className="flex flex-col items-center">
      <div className="flex items-end text-center align-text-bottom">
        <span className="mr-1 text-sm font-normal !leading-8 text-gray-8">
          from
        </span>
        <h5 className="mr-1 text-2xl text-black-0">
          {formatCurrency(min_total_nt, false, false)}
        </h5>
        {hasMaxTotal && (
          <>
            <span className="mr-1 text-sm font-normal !leading-8 text-gray-8">
              to
            </span>
            <h5 className="text-2xl text-black-0">
              {formatCurrency(max_total_nt, false, false)}
            </h5>
          </>
        )}
      </div>
      <span className="ut-xxs whitespace-nowrap font-normal text-gray-8">
        Average nightly rate before taxes
      </span>
    </div>
  );
};

export default PriceRange;
